import './instagram_dm_content.js.coffee'
Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.InstagramLikeDMContent extends Monitoring.Models.SocialContents.InstagramDMContent
  getMainText: ->
    '\u2764\ufe0f'
